import { render, staticRenderFns } from "./InvestorProfileForm.vue?vue&type=template&id=6915c2b4&scoped=true"
import script from "./InvestorProfileForm.vue?vue&type=script&lang=js"
export * from "./InvestorProfileForm.vue?vue&type=script&lang=js"
import style0 from "./InvestorProfileForm.vue?vue&type=style&index=0&id=6915c2b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915c2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6915c2b4')) {
      api.createRecord('6915c2b4', component.options)
    } else {
      api.reload('6915c2b4', component.options)
    }
    module.hot.accept("./InvestorProfileForm.vue?vue&type=template&id=6915c2b4&scoped=true", function () {
      api.rerender('6915c2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/exhibit-b-investor-profile/InvestorProfileForm.vue"
export default component.exports